import './apiVersion.interceptor';

const apiVersions: Record<string, string> = {};

const apiVersionService = {
  getApiVersion(serviceKey: string) {
    return apiVersions[serviceKey];
  },
  setApiVersion(serviceKey: string, value: string) {
    apiVersions[serviceKey] = value;
  },
};

export default apiVersionService;
